
                import "css-modules://src_components_page"
                export default {"Main":"_190b32","Title":"_9d7193","Inner":"_52bf57"}
            